// extracted by mini-css-extract-plugin
export default {"card":"StaffCard_card__NFRzz","editButton":"StaffCard_editButton__mf70d"};